// extracted by mini-css-extract-plugin
module.exports = {"patientDashboard":"style_patientDashboard__2pSic","tabs":"style_tabs__3h1CJ","active":"style_active__3_2ZD"};